import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ENDPOINT } from '@core/configs';
import { ApiResponse } from '@core/models/interfaces';
import { ApiService } from '../common';
import { PassOrganizationResponse } from '@pages/authorized/careposi/organization-management/organization-management.model';

@Injectable({
  providedIn: 'root',
})
export class CorpService {
  constructor(private readonly http: ApiService) {}

  getOrganizations(): Observable<ApiResponse<PassOrganizationResponse[]>> {
    const url = `${API_ENDPOINT.authConsole.get_organizations}`;
    return this.http.get(url);
  }
}
